import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { useRole } from '@ztechapps/common.hook'
import { productPermissions, useImportProductWithSpec } from '@ztechapps/product.common'
import { useMetadataContext } from '../Context'

export const ImportSpecificationsButton = () => {
  const { compact } = useMetadataContext()
  const { uploadFileInputRef, getInputProps, loading, onFileInputClick } = useImportProductWithSpec()

  const label = 'Import Spec'
  const { hasRole } = useRole({ roleName: productPermissions.canEdit.value })
  return (
    <>
      <BusyButton
        onClick={onFileInputClick}
        icon="upload"
        title="Import Fusion 360 file"
        busyText={compact ? '' : 'Importing....'}
        text={compact ? '' : label}
        isBusy={loading}
        disabledReason={
          !hasRole ? 'Import Fusion 360 file — you do not have permission to edit this product' : undefined
        }
        aria-label={compact ? label : undefined}
      />
      <input {...getInputProps()} ref={uploadFileInputRef} />
    </>
  )
}
